module.exports = __webpack_public_path__ + "img/e89751e.jpg";